import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { iusuario } from '../models/iusuario.model';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ImagenBase64 } from '../models/imagenBase64.model';

@Injectable({
    providedIn: 'root'
})
export class UsuarioService {

    constructor(private apiService: ApiService,
        private httpClient: HttpClient
    ) { }

    insertar_propiedad(data: any): Observable<any> {
        return this.httpClient.post(environment.serviceUrl + "usuario-propiedad", data, { observe: 'response' })
    }

    actualizar_propiedad(data: any): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "usuario-propiedad", data, { observe: 'response' })
    }

    eliminar_propiedad(codpro: number, coduser: string): Observable<any> {
        return this.httpClient.delete(environment.serviceUrl + "usuario-propiedad/" + codpro + "?coduser=" + coduser, { observe: 'response' })
    }


    obtener_propiedad(codpro: number, coduser: string): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario-propiedad/" + codpro + "?coduser=" + coduser, { observe: 'response' })
    }


    buscar_propiedad2(coduser: string, descri: any): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario-propiedad/buscar?coduser=" + coduser + "&descri=" + encodeURIComponent(descri), { observe: 'response' })
    }

    buscar_propiedad(coduser: string): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario-propiedad/buscar?coduser=" + coduser, { observe: 'response' })
    }

    buscarAccesos(coduser: string, codmod: number): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario/" + coduser + "/accesos?codmod=" + codmod, { observe: 'response' })
    }


    logout(coduser: string): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "usuario/" + coduser + "/logout", null, { observe: 'response' })
    }
    logout_v2(cia: number, coduser: string, id: number): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + "usuario/" + cia + "/logout/v2?coduser=" + coduser + "&id=" + id, null, { observe: 'response' })
    }
    insertarUsuario(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_insertar_url);
        return this.apiService.executePostJson(data).pipe();
    }

    obtenerUsuarios(coduser: string, nombres: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_buscar);
        return this.apiService.execGetQueryJson(`coduser=${coduser}&nombres=${encodeURI(nombres)}`)
    }

    obtenerUsuariosMasivo(coduser: string, nombres: string, masivo: boolean): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_masivo_buscar);
        return this.apiService.execGetQueryJson(`coduser=${coduser}&nombres=${encodeURI(nombres)}&masivo=${masivo}`)
    }

    obtener(coduser: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_obtener);
        return this.apiService.execGetQueryJson(`${coduser}`)
    }

    actualizar(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_actualizar);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_eliminar);
        return this.apiService.executeDeleteJson(data).pipe();
    }

    updatecontrasenia(data: iusuario): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_cambiar_contra);
        return this.apiService.executePutJson(data).pipe();
    }

    borrarSessiones(coduser: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.usuario_eliminar + coduser + "/borrar-sesiones");
        return this.apiService.executePutJson('').pipe();
    }
    borrarSessiones2(cia: any, coduser: any, id: any) {
        this.apiService.setUrlPathApi(`usuario/${cia}/logout/v2`);
        return this.apiService.executePutQueryParam(`?coduser=${coduser}&id=${id}`).pipe();
    }

    /****************MANTENIMIENTO PERMISOS USUARIO*************************/

    /****guardar nuevo acceso*****/

    insertAcceso(coduser: any, data: any): Observable<any> {
        return this.httpClient.post(environment.serviceUrl + `usuario/${coduser}/accesos`, data, { observe: 'response' })
    }

    delete_acceso(coduser: any, codmod: any, codacc: any): Observable<any> {
        return this.httpClient.delete(environment.serviceUrl + `usuario/${coduser}/accesos/${codmod}/${codacc}`, { observe: 'response' })
    }
    updateAcceso(coduser: any, codmod: any, codacc: any, accion: 'C' | 'E'): Observable<any> {
        const params = new HttpParams().set('accion', accion);
        return this.httpClient.put(environment.serviceUrl + `usuario/${coduser}/accesos/${codmod}/${codacc}`, null, { params });
    }
    updateAccesoMasivo(codmod: any, codacc: any, usuarios: any[]): Observable<any> {
        return this.httpClient.put(environment.serviceUrl + `usuario/accesos/masivo/${codmod}/${codacc}`, usuarios);
    }


    /********Impresion contraseñas******** */

    imprimir_claves(coduser: any, nombres: any) {//sin descuento
        const fullUrl = environment.serviceUrl_Report + ROUTES_ARCHIVOS.usuario_print + `coduser=${coduser}&nombres=${encodeURI(nombres)}`;
        // const fullUrl = environment.serviceUrl + `cotizacion/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.httpClient.get(fullUrl, httpOptions);
    }

    //-----------------SERVICIOS DE IMAGEN ------------------

    insertarImagenVendedor(coduser: string, imagenBase64: ImagenBase64): Observable<any> {
        this.apiService.setUrlPathApi('usuario/' + coduser + '/firma');
        return this.apiService.executePostJson(imagenBase64).pipe();
    }

    actualizarImagenVendedor(coduser: string, imagenBase64: ImagenBase64): Observable<any> {
        this.apiService.setUrlPathApi('usuario/' + coduser + '/firma');
        return this.apiService.executePutJson(imagenBase64).pipe();
    }

    getFirma(coduser: string): Observable<any> {
        this.apiService.setUrlPathApi('usuario/' + coduser + '/firma');
        return this.apiService.execGetQueryJson(``)
    }
    //servicio para obtener firma
    obtenerFirma_v2(id_cia: any, coduser: any, item?: any) {
        this.apiService.setUrlPathReportes('usuario/' + id_cia + '/public/' + coduser + '/firma');
        let queryParams = '';
        if (item !== undefined) {
            queryParams = `?item=${item}`;
        }
        return this.apiService.execGetQueryJson(`?item=${item}`);
    }
    deleteImagenVendedor(coduser: string, item?: number): Observable<any> {
        this.apiService.setUrlPathApi('usuario/' + coduser + '/firma');
        let queryParams = '';
        if (item !== undefined) {
            queryParams = `?item=${item}`;
        }
        return this.apiService.executeDeleteJson(queryParams)
    }
    /** Mantenimiento de modulos */
    insertModulos(sender: any) {
        this.apiService.setUrlPathApi('usuario/modulos');
        return this.apiService.executePostJson(sender).pipe();
    }
    updateModulos(sender: any) {
        this.apiService.setUrlPathApi(`usuario/modulos`)
        return this.apiService.executePutJson(sender).pipe();
    }
    deleteModulos(coduser: any, codmod: any) {
        this.apiService.setUrlPathApi(`usuario/modulos/${coduser}`);
        return this.apiService.executeDeleteJson(`?codmod=${codmod}`)
    }
    obtenerModulos(coduser: any, codmod: any) {
        this.apiService.setUrlPathApi(`usuario/modulos/${coduser}`);
        return this.apiService.execGetQueryJson(`?codmod=${codmod}`);
    }
    buscarModulos(coduser: any, codmod: any, swacti: any) {
        this.apiService.setUrlPathApi('usuario/modulos/buscar');
        return this.apiService.execGetQueryJson(`?coduser=${coduser}&codmod=${codmod}&swacti=${swacti}`);
    }
    /************ USUARIOS GRUPOS ******************* */
    buscarGrupoUsuario(codgrupo: any, coduser: any) {
        this.apiService.setUrlPathApi('usuario-grupo/buscar');
        return this.apiService.execGetQueryJson(`?codgrupo=${codgrupo}&coduser=${coduser}`);
    }
    insertGrupoUsuario(data: any) {
        this.apiService.setUrlPathApi('usuario-grupo');
        return this.apiService.executePostJson(data).pipe();
    }
    updateGrupoUsuario(data: any) {
        this.apiService.setUrlPathApi(`usuario-grupo`)
        return this.apiService.executePutJson(data).pipe();
    }
    deleteGrupoUsuario(coduser: any, codgrupo: any) {
        this.apiService.setUrlPathApi(`usuario-grupo/${coduser}/${codgrupo}`);
        return this.apiService.executeDeleteJson('')
    }
    obtenerGrupoUsuario(coduser: any, codgrupo: any) {
        this.apiService.setUrlPathApi(`usuario-grupo/${coduser}/${codgrupo}`);
        return this.apiService.execGetJson();
    }
    /************ GRUPOS USUARIOS ******************* */
    buscarGrupo(desgrupo: any, swacti: any) {
        this.apiService.setUrlPathApi('grupo-usuario/buscar');
        return this.apiService.execGetQueryJson(`?desgrupo=${desgrupo}&swacti=${swacti}`);
    }
    insertGrupo(data: any) {
        this.apiService.setUrlPathApi('grupo-usuario');
        return this.apiService.executePostJson(data).pipe();
    }
    updateGrupo(data: any) {
        this.apiService.setUrlPathApi(`grupo-usuario`)
        return this.apiService.executePutJson(data).pipe();
    }
    deleteGrupo(codgrupo: any) {
        this.apiService.setUrlPathApi(`grupo-usuario/${codgrupo}`);
        return this.apiService.executeDeleteJson('')
    }
    obtenerGrupo(codgrupo: any) {
        this.apiService.setUrlPathApi(`grupo-usuario/${codgrupo}`);
        return this.apiService.execGetJson();
    }

    /*****************************USUARIOS CONECTADOS**************************** */

    obtenerConectados() {
        this.apiService.setUrlPathApi('usuario/en-linea');
        return this.apiService.execGetJson();
    }

    obtenerUsuariosEnLinea() {
        this.apiService.setUrlPathApi("usuario/v2/en-linea");
        return this.apiService.execGetJson();
    }

    /*****************************PANEL DE CONTROL**************************** */

    buscar_propiedad_v2(coduser: string): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "usuario-propiedad/buscar?coduser=" + coduser, { observe: 'response' })
    }

    obtener_v2(coduser: string): Observable<any> {
        this.apiService.setUrlPathERPApi(ROUTES_ARCHIVOS.usuario_obtener);
        return this.apiService.execGetQueryJson(`${coduser}`)
    }

    actualizar_V2(data: iusuario): Observable<any> {
        this.apiService.setUrlPathERPApi(ROUTES_ARCHIVOS.usuario_actualizar);
        return this.apiService.executePutJson(data).pipe();
    }
    usuariosPropiedades(coduser: any): Observable<any> {
        return this.httpClient.get(`${environment.serviceUrl}propiedades-usuario/buscar/${coduser}`, { observe: 'response' });
    }
    registrarPropiedadesMasivo(coduser_destino: any, sender: any): Observable<any> {
        return this.httpClient.post(`${environment.serviceUrl}propiedades-usuario/propiedades/${coduser_destino}`, sender, { observe: 'response' });
    }

    buscarHistorialAuditoriaUsuario(coduser: string) {
        return this.httpClient.get(environment.serviceUrl + `usuario/historial-auditoria/${coduser}`)
    }

    buscarHistorialEliminacionUsuario() {
        return this.httpClient.get(environment.serviceUrl + `usuario/historial-eliminacion`)
    }

}